var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_340_2694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.061 0.548828H4.93901C2.21563 0.548828 0 2.76446 0 5.48784V39.5122C0 42.2356 2.21563 44.4513 4.93901 44.4513H40.061C42.7845 44.4513 45 42.2356 45 39.5122V5.48784C45 2.76446 42.7845 0.548828 40.061 0.548828ZM8.78045 41.1586H4.93901C4.03119 41.1586 3.29265 40.4201 3.29265 39.5122V13.7196H8.78045V41.1586ZM41.7074 39.5122C41.7074 40.4201 40.9689 41.1586 40.061 41.1586H12.0732V13.7196H41.7074V39.5122ZM41.7074 10.4269H3.29265V5.48784C3.29265 4.58002 4.03119 3.84147 4.93901 3.84147H40.061C40.9689 3.84147 41.7074 4.58002 41.7074 5.48784V10.4269Z",
    fill: "#1E4161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.061 5.48779H22.5V8.78044H40.061V5.48779Z",
    fill: "#1E4161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4757 19.7563L26.405 19.7546L28.7767 22.1265L18.043 32.8603L20.3711 35.1885L31.1049 24.4548L33.4765 26.8262L33.4757 19.7563Z",
    fill: "#1E4161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58578 9.32928C7.79813 9.32928 8.78094 8.34647 8.78094 7.13412C8.78094 5.92177 7.79813 4.93896 6.58578 4.93896C5.37343 4.93896 4.39062 5.92177 4.39062 7.13412C4.39062 8.34647 5.37343 9.32928 6.58578 9.32928Z",
    fill: "#1E4161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_340_2694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.bfe83acc58fc104addb99aa2ed27072c.svg";
export { ForwardRef as ReactComponent };